var distributionProgressTooltipTemplate = require('html/templates/distributionProgressTooltip')();
var distributionRoutePlanProgressTooltipTemplate = require('html/templates/distributionRoutePlanProgressTooltip')();
var distributionRoutesProgressTooltipTemplate = require('html/templates/distributionRoutesProgressTooltip')();
var distributionOutdatedAppTooltipTemplate = require('html/templates/distributionOutdatedAppTooltip')();
var routeStatusTooltipTemplate = require('html/templates/routeStatusTooltip')();
var routeInfoTooltipTemplate = require('html/templates/routeInfoTooltip')();
var deliveryInfoTooltipTemplate = require('html/templates/deliveryInfoTooltip')();
var notificationsTooltipTemplate = require('html/templates/notificationsTooltip')();
var customerTimestampTooltipTemplate = require('html/templates/customerTimestampTooltip')();
var customerCallLogTooltipTemplate = require('html/templates/customerCallLogTooltip')();
var util = require('js/lib/util');
var moment = require('js/lib/moment');

distributionCtrl.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$controller', 'load', 'editRoutePlan'];

function distributionCtrl($scope, $rootScope, $routeParams, $location, $controller, load, editRoutePlan) {

  $controller('commonCtrl', { $scope: $scope });

  $scope.distributionProgressTooltipTemplate = distributionProgressTooltipTemplate;
  $scope.distributionRoutePlanProgressTooltipTemplate = distributionRoutePlanProgressTooltipTemplate;
  $scope.distributionOutdatedAppTooltipTemplate = distributionOutdatedAppTooltipTemplate;
  $scope.distributionRoutesProgressTooltipTemplate = distributionRoutesProgressTooltipTemplate;
  $scope.routeStatusTooltipTemplate = routeStatusTooltipTemplate;
  $scope.routeInfoTooltipTemplate = routeInfoTooltipTemplate;
  $scope.deliveryInfoTooltipTemplate = deliveryInfoTooltipTemplate;
  $scope.notificationsTooltipTemplate = notificationsTooltipTemplate;
  $scope.customerTimestampTooltipTemplate = customerTimestampTooltipTemplate;
  $scope.customerCallLogTooltipTemplate = customerCallLogTooltipTemplate;

  // EditRoutePlan-service (mappings)
  $scope.openEditRoutePlan = editRoutePlan.openEditRoutePlan.bind(this, $scope);
  $scope.saveRoutePlan = editRoutePlan.saveRoutePlan.bind(this, $scope);
  $scope.deleteRoutePlan = editRoutePlan.deleteRoutePlan.bind(this, $scope);

  $scope.archive = $location.hash() === 'archive';
  $scope.isDeviationsPage = $scope.router.page() === 'distribution/deviations';
  $scope.query = $routeParams.q;

  $scope.search = {
    delayed: undefined,
    customer: $scope.query
  };

  var loadData = function(date, distrNo) {
    $scope.customers = null;

    if (date) {
      $scope.distributions = null;
      load.distribution(date, distrNo).then(loadCustomers);
    } else {
      $scope.distribution = null;
      load.distributions();
    }

    load.customerSystems();
    $scope.loadCommonData();
  };

  var loadCustomers = function(distribution) {

    var setCustomers = function(customers) {
      if ($scope.distribution) {
        $scope.distribution.customers = customers;
        $scope.customers = $scope.distribution.customers;
      }
    };

    setCustomers(null);

    if ($scope.isDeviationsPage) {
      load.distributionCustomers(distribution, 'deviations').then(setCustomers);
    } else if ($scope.query) {
      load.distributionCustomers(distribution, 'search', $scope.query).then(setCustomers);
    }
  };

  if ($rootScope.auth) {
    loadData($routeParams.date, +$routeParams.distrNo);
  }

  $scope.dataLoaded = function() {
    if (! $rootScope.auth) return true;
    if (! $scope.commonDataLoaded()) return false;

    if ($routeParams.date) {
      return $scope.distribution &&
             $scope.distribution.date === $routeParams.date &&
             $scope.distribution.distrNo === +$routeParams.distrNo &&
             ($scope.customers || ! ($scope.query || $scope.isDeviationsPage)) &&
             true;
    } else {
      return $scope.distributions && true;
    }
  };

  $scope.customerSystemNames = function(routePlans) {
    var customerSystemIdMap = {};
    routePlans.forEach(function(routePlan) {
      routePlan.customerSystems.forEach(function (csId) {
        customerSystemIdMap[csId] = csId;
      });
    });

    var name = function(id) {
      if ($scope.customerSystems && $scope.customerSystems[id]) {
        return $scope.customerSystems[id].name;
      }
      return '???';
    };

    return (Object.keys(customerSystemIdMap) || [])
      .map(name)
      .filter(Boolean) // The routePlan may contain customerSystems not included in $scope.customerSystems
      .sort();
  };

  $scope.estimatedTimeAdjustedByRoute = function(estimatedTimestamp, routeId) {
    var route = $scope.distribution.findRoute(routeId);
    if (route && route.delayInMinutes()) {
      var minutes = route.delayInMinutes();
      if (minutes) {
        return moment(estimatedTimestamp).add(minutes, 'minutes');
      }
    }
    return estimatedTimestamp;
  };

  $scope.delayedCustomer = function(actually, estimated) {
    return util.delayForHumans(util.delayInMinutes(util.toDate(actually), util.toDate(estimated)));
  };

  $scope.formatPhone = require('js/lib/util').formatPhone;

  $scope.goToSearch = function() {
    var url = $scope.router.link('distribution', null, $scope.distribution) + '/search';

    $location.path(url.replace('#', '')).search('q', $scope.search.customer);
  };

}

module.exports = distributionCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/distributionCtrl.js
 ** module id = 126
 ** module chunks = 1
 **/